import script from "./SecurityOfficerLoginsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SecurityOfficerLoginsView.vue?vue&type=script&setup=true&lang=js"

import "./SecurityOfficerLoginsView.vue?vue&type=style&index=0&id=24a3bef6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24a3bef6"]])

export default __exports__